export type EntityId = number;

export const MAX_OUTLINES = 16;
